import axiosInstance from '../superadminAxiosInstance';
import { BaseService } from './baseService';

class AnnouncementsService extends BaseService<
	Announcement,
	'announcementID',
	'announcements'
> {
	constructor() {
		super('announcementID', 'announcement', 'announcements');
	}

	async deleteMultipleAnnouncements(
		data: DeleteMultipleAnnouncementsRequest,
	): Promise<void> {
		await axiosInstance.post(
			`/superAdmin/${this.crudResponseArrayName}/batch`,
			data,
		);
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new AnnouncementsService();
